import { apiFetch } from "@/lib/api";

export type Tour = {
  id: number;
  tour_code: string;
  title: string;
  description?: string | null;
  duration_hours: number;
  type: string;
  pricing_type: string;
  max_capacity?: number | null;
  image_url?: string | null;
  price_op?: number | null;
  price_ag?: number | null;
  price_cf?: number | null;
  supplier_name?: string | null;
  cost_supplier?: number | null;
  cost_supplier_extra_hour?: number | null;
  price_extra_hour_op?: number | null;
  price_extra_hour_ag?: number | null;
  price_extra_hour_cf?: number | null;
  tax_percentage?: number | null;
  hcte_notes?: string | null;
  created_at?: string;
  updated_at?: string;
};

export type TourListItem = {
  id: number;
  tour_code: string;
  title: string;
  type: string;
  duration_hours: number;
  price_op?: number | null;
};

export type TourListResponse = {
  items: TourListItem[];
  total: number;
};

export const fetchTours = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<TourListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  const payload = await apiFetch<TourListResponse | null>(`/tours?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getTour = async (id: number): Promise<Tour> => {
  return apiFetch<Tour>(`/tours/${id}`);
};

export const createTour = async (data: Partial<Tour>): Promise<Tour> => {
  return apiFetch<Tour>("/tours", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const createTourAllowDuplicates = async (data: Partial<Tour>): Promise<Tour> => {
  return apiFetch<Tour>("/tours?allow_duplicates=true", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateTour = async (id: number, data: Partial<Tour>): Promise<Tour> => {
  return apiFetch<Tour>(`/tours/${id}` , {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteTour = async (id: number): Promise<void> => {
  await apiFetch<void>(`/tours/${id}`, { method: "DELETE" });
};

export const deleteAllTours = async (): Promise<void> => {
  await apiFetch<void>("/tours", { method: "DELETE" });
};
